import { BnAction } from '../common/bn-action';

class EntityNoteSave extends BnAction {
  constructor() {
    super();
    this.successtext = 'Note has been saved.';
    this.errortext = 'Failed to save note.';
    this.submittext = 'Save';
    this.suppressheader = true;
  }

  static get properties() {
    return {
      clearOnSuccess: { type: Boolean, attribute: 'clear-on-success' },
    };
  }

  preRender(action) {
    const message = action.getFieldByName('message');
    message.type = 'textarea';
    message.title = '';
    message.rows = 7;

    const type = action.getFieldByName('type');
    type.type = 'hidden';
    type.value = 'biosecurity';
  }

  async submit() {
    if (!this.entity.hasAction(this.actionname)) {
      return;
    }

    const fields = [...this.shadowRoot.querySelectorAll('bn-form-field')];
    const messageField = fields.find(f => f.name === 'message');
    messageField.input.value = messageField.input.value.trim();

    const response = await super.submit();
    if (this.clearOnSuccess && !response.error) {
      messageField.input.value = '';
    }
    return response;
  }
}

window.customElements.define('entity-note-save', EntityNoteSave);
